module.exports = __webpack_public_path__ + "res/st_long_logo_lg.png";